"use client";
import React from "react";
import { renderBlockContent } from "../kit/blocks";
import { motion } from 'framer-motion';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";


import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Heading } from "../kit/Heading";
import "yet-another-react-lightbox/plugins/captions.css";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3
  }
};


export default function SectionImages({ data, mainColor }) {
  const [open, setOpen] = React.useState(false);
  const [index, setIndex] = React.useState(0);
  const images = data.sectionImages.images;

  return (
    <div>
      <div className="container mx-auto px-5 flex">
        <div className="w-full md:w-1/2">
          <Heading data={data.sectionImages.heading} />
          {data.sectionImages.text && (
            <div>{renderBlockContent(data.sectionImages.text)}</div>
          )}
        </div>
      </div>
      <div className="container mx-auto py-5 ">
        <div className={"grid grid-cols-2 gap-4 md:grid-cols-4 "}>
          {images.map((image, index) => (
            <div className={"w-full h-50 cursor-pointer"} key={"img" + Math.random()} >

   

              <motion.img
                src={image.image.asset.url}
                alt={image.title}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
                className="w-full h-full object-cover"
                onClick={() => { setOpen(true); setIndex(index) }}
              />
            </div>
          ))}
        </div>
      </div>

      <Lightbox
        index={index}
        open={open}
        close={() => setOpen(false)}
        plugins={[Captions]}
        slides={
          images.map((image) => {
            return { src: image.image.asset.url, title: image.description }
          })
        }
      />

    

    </div>
  );
}